import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export type InlineNoticeVariant = 'info' | 'success' | 'warning' | 'error';

export const NoticeWrapper = styled.div<{ variant: InlineNoticeVariant }>(
    ({ theme: { palette }, variant }) => css`
        align-items: flex-start;
        background-color: ${variant === 'error'
            ? palette.semantic.errorBg
            : palette.neutral.lightGrey};
        border-left: 3px solid
            ${variant === 'error'
                ? palette.semantic.error
                : variant === 'warning'
                  ? palette.semantic.alert
                  : variant === 'success'
                    ? palette.semantic.success
                    : palette.neutral.dividers};
        border-radius: 4px;
        display: flex;
        gap: 8px;
        margin-top: 12px;
        padding: 12px;
        width: 100%;
    `,
);

export const NoticeIcon = styled.span<{ variant: InlineNoticeVariant }>(
    ({ theme: { palette }, variant }) => css`
        color: ${variant === 'error'
            ? palette.semantic.error
            : variant === 'warning'
              ? palette.semantic.alert
              : variant === 'success'
                ? palette.semantic.success
                : palette.text.assistive};
        display: flex;
        flex-shrink: 0;
        line-height: 0;
        padding-top: 2px;
    `,
);

export const NoticeText = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.primary};
    `,
);
